import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const clockify = defineConnector({
  identifier: "clockify",
  name: "Clockify",
  tagLine: "Time tracking and timesheets",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.clockify\\.me/.*",
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your Clockify API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Clockify Profile Settings](https://app.clockify.me/user/settings) and scroll down to the **API** section to find your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API Key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.clockify.me/api/v1/user",
  },
});
